import React from 'react';
import { BooleanField, NumberField } from 'react-admin';
import {
    Datagrid,
    DateField,
    TextField,
    Filter,
    List,
    SearchInput,
    BooleanInput,
    ReferenceInput,
    SelectInput,
    EditButton,
} from 'react-admin';
import QuizStatusField from './fields/QuizStatusField';
import QuizSubmitsBtn from './fields/QuizSubmitsBtn';
import CloseQuizBtn from './fields/CloseQuizBtn';
const QuizFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <BooleanInput
            source="is_enabled"
            label="resources.quizzes.fields.is_enabled"
        />
        <BooleanInput
            source="is_closed"
            label="resources.quizzes.fields.is_closed"
        />
        <ReferenceInput
            alwaysOn
            emptyText="resources.teams.all"
            label="resources.users.fieldGroups.team"
            source="teams"
            reference="teams"
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);
const PostList = (props: any) => {
    return (
        <List
            {...props}
            filters={<QuizFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
        >
            <Datagrid optimized rowClick="">
                <TextField
                    source="title"
                    label="resources.quizzes.fields.title"
                />
                <QuizStatusField label="resources.quizzes.fields.status" />

                <NumberField
                    source="questions_count"
                    label="resources.quizzes.fields.questions_count"
                />
                <NumberField
                    source="submits_count"
                    label="resources.quizzes.fields.submits_count"
                />
                <BooleanField
                    source="is_closed"
                    label="resources.quizzes.fields.is_closed"
                />
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.quizzes.fields.created_at"
                />
                <EditButton label="resources.quizzes.actions.edit" />
                <QuizSubmitsBtn label="resources.quizzes.actions.submits" />
                <CloseQuizBtn label="resources.quizzes.actions.close" />
            </Datagrid>
        </List>
    );
};

export default PostList;
